import { Component } from '@angular/core';
import { DnButtonBaseComponent } from '../base/dn-button-base/dn-button-base.component';
import { elemShow } from '../../constants/animations';

@Component({
  selector: 'dn-primary-btn',
  templateUrl: './dn-primary-btn.component.html',
  styleUrl: './dn-primary-btn.component.scss',
  animations: [elemShow],
  standalone: false,
})
export class DnPrimaryBtnComponent extends DnButtonBaseComponent {}
